import React from "react";
import NewsRelated from "./NewsRelated";
import { Link, useNavigate, useParams } from "react-router-dom";
import { BaseUrl } from "../../helper/BaseUrl";
import { DateConvert } from "../../helper/DateConvert";

export default function NewDetailContent({ initialData }) {
  const { slug } = useParams();
  const [aiData, setAiData] = React.useState(initialData || {});
  const navigate = useNavigate();
  const [pageUrl, setPageUrl] = React.useState("");
  const [copied, setCopied] = React.useState(false);
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      setPageUrl(window.location.href);
    }
  }, []);

  const handleCopy = async () => {
    if (typeof window !== "undefined" && pageUrl) {
      try {
        await navigator.clipboard.writeText(pageUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 10000); // reset after 10s
      } catch (err) {
        console.error("Copy failed:", err);
      }
    }
  };

  const aifetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/media/view/${slug}`, {
        method: 'GET',
      });
      const result = await response.json();
      if (!result.media) {
        navigate("/404");
        return;
      }
      setAiData(result.media);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };
  React.useEffect(() => {
    aifetcher();
  }, [slug])


  if (!aiData) {
    return null;
  }


  return (
    <>
      <section className="news-details-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <ul className="dynamic-breadcrumb">
                <li><Link to={"/"}>Home</Link> </li>
                <li><Link to={"/news"}>News</Link> </li>
                <li><Link>{aiData?.title ? aiData.title.slice(0, 20) + "..." : ""}</Link></li>
              </ul>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-9">
              <div className="news-top-sec">
                <div className="news-category">
                  <span>{DateConvert(aiData?.date)}</span>
                </div>
                <h1 className="heading">
                  {aiData?.title}
                </h1>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="news-banner">
                <img src={aiData?.banner ? BaseUrl + aiData.banner : undefined} className="img-responsive" alt={aiData?.alt_banner} />
              </div>
              <div className="news-content-wrapper">
                <div className="content-inner">
                  <div dangerouslySetInnerHTML={{ __html: aiData?.description }} />
                </div>
                <div className="news-author-sec">
                  <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6">
                      <div className="author-sec">
                        <div className="icon-wrap">
                          <img src={aiData?.author_image ? BaseUrl + aiData?.author_image : "/assets/images/author-images.webp"} alt={aiData?.author_name} className="img-responsive" />
                        </div>
                        <div className="content-wrap">
                          <strong>Written by {aiData?.author_name}</strong>
                          <p>{DateConvert(aiData?.date)}</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6">
                      <div className="news-social">
                        <ul>
                          <ul>
                            <li title={copied ? "Copied!" : "Copy link"}>
                              <Link to="#" onClick={handleCopy} rel="noopener noreferrer" >   <i className="fa-solid fa-link"></i> </Link>
                            </li>
                            <li>
                              <Link to={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(pageUrl)}`} target="_blank" rel="noopener noreferrer"> <i className="fa-brands fa-linkedin-in"></i></Link>
                            </li>
                          </ul>

                        </ul>
                      </div>
                    </div>

                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}





